import { useEffect, useRef } from 'react'
import { useAppDispatch } from '../dispatch'
import { isEmptyRange } from '../workbook'
import { deleteReferencesWithBindingIds } from '../slice/referenceSlice'

import { ResultAsync } from 'neverthrow'
import mittEmitter from '../utils/mitt'
import PQueue from 'p-queue'
import { store } from '../store'

const useBindingOnDataChangeEventReceiver = () => {
  const dispatch = useAppDispatch()
  const dispatchRef = useRef(dispatch)
  dispatchRef.current = dispatch

  const pQueueRef = useRef(new PQueue({ concurrency: 1 }))

  useEffect(() => {
    const handler = (bindingId: string) => {
      mittEmitter.emit('PROCESS_BINDING_ON_DATA_CHANGE', bindingId)
    }
    // window.addEventListener(AppCustomEvent.BINDING_ON_DATA_CHANGE, handler)
    mittEmitter.on('BINDING_ON_DATA_CHANGE', handler)

    return () => {
      mittEmitter.off('BINDING_ON_DATA_CHANGE', handler)
    }
  }, [])

  useEffect(() => {
    const handler = (bindingId: string) => {
      pQueueRef.current.add(async () => {
        const references = store.getState().references.references
        const filtered = references.find((ref) => ref.bindingId === bindingId)
        if (!filtered) return
        let toBeDelete: string[] = []
        if (filtered.bindingGroupId) {
          const bindingGroup = references.filter(
            (ref) => ref.bindingGroupId === filtered.bindingGroupId
          )
          toBeDelete = bindingGroup.map((ref) => ref.bindingId)
        } else {
          toBeDelete = [filtered.bindingId]
        }

        const isEmptyRangeResult = await ResultAsync.fromPromise(
          isEmptyRange(bindingId),
          () => new Error('Invalid binding')
        )
        const isEmpty = isEmptyRangeResult.match(
          (empty) => empty,
          () => true
        )

        if (isEmpty) {
          const deleteResult = await ResultAsync.fromPromise(
            dispatchRef.current(
              deleteReferencesWithBindingIds({
                bindingIds: toBeDelete,
                deleteGroup: true,
              })
            ),
            (error) =>
              new Error(
                `Failed to delete references with ids=${toBeDelete}, error: ${error}`
              )
          )

          if (deleteResult.isErr()) {
            console.error(deleteResult.error)
          }
        }
      })
    }
    mittEmitter.on('PROCESS_BINDING_ON_DATA_CHANGE', handler)

    return () => mittEmitter.off('PROCESS_BINDING_ON_DATA_CHANGE', handler)
  }, [])
}

export default useBindingOnDataChangeEventReceiver
